export default "__VITE_ASSET__D7PFz844__"